// extracted by mini-css-extract-plugin
export default {"parkingSpaces":"styles_parkingSpaces__EylQG","holder":"styles_holder__nzAyW","count":"styles_count__xfcoR","removeWrapper":"styles_removeWrapper__cmZWO"};